import React from "react";
import { Box, Typography } from "@mui/material";

import { style } from "./style";

import defaultProfilePic from "@/assets/patient.png";

import { IHospitalTeam } from "@/models/ApiRequestResponse/doctor";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  ipDashboardDetails,
  setViewHospitalTeamDetail,
} from "@/store/slices/doctor/ipDashboard";

const TeamCard: React.FC<IHospitalTeam> = (props) => {
  const { name, profileUrl, role, userId } = props;

  const { viewHospitalTeamDetail } = useAppSelector(ipDashboardDetails);
  const { userId: selectedUserId } = viewHospitalTeamDetail;

  const dispatch = useAppDispatch();

  const selectTeamDetailHandler = () => {
    dispatch(setViewHospitalTeamDetail(props));
  };

  return (
    <Box
      sx={{
        ...style.card,
        ...(userId === selectedUserId ? style.active : {}),
      }}
      onClick={selectTeamDetailHandler}
    >
      <Box
        component="img"
        src={profileUrl || ""}
        alt={name}
        sx={style.avatar}
        onError={(e) => (e.currentTarget.src = defaultProfilePic)}
      />
      <Box sx={style.teamDetail}>
        <Typography component={"p"} sx={style.name}>
          {name}
        </Typography>
        <Typography component={"p"} sx={style.role}>
          {role ?? "No Role"}
        </Typography>
      </Box>
    </Box>
  );
};

export default TeamCard;
